import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// Menu
export interface Menu {
	path?: string;
	title?: string;
   type?: string;
   icon?:string;
	badgeType?: string;
	badgeValue?: string;
   active?: boolean;
   megaMenu?: boolean;
   megaMenuType?: string; // small, medium, large
	bookmark?: boolean;
	children?: Menu[];
}

@Injectable({
  providedIn: 'root'
})
export class NavService {

  constructor() {   }

  MENUITEMS: Menu[] = [
      {
          title: 'Tabellen', type: 'sub', children: [
              { path: 'branchen-uebersicht', title: 'Vorhandene Tabellen',  type: 'link' },
          ]
      },
      {
          title: 'Konfigurieren', type: 'sub', children: [
              { path: '/liste-konfigurieren', title: 'Tabelle Erstellen',  type: 'link' },
              { path: '/features', title: 'Features',  type: 'link' },

          ]
      },
      {
          title: 'Kontakt', type: 'sub', children: [
              { path: '/kontakt', title: 'Kontakt',  type: 'link' },
              { path: '/faq', title: 'FAQ',  type: 'link' },
              { path: '/services', title: 'Services',  type: 'link' },
              { path: '/impressum', title: 'Impressum',  type: 'link' },
              { path: '/warum-palladio', title: 'Warum Palladio',  type: 'link' },
              { path: '/dsgvo', title: 'DSGVO',  type: 'link' },
          ]
      },
   ]
  
  	// Array
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
   
}
